import FocusedLayout from './event-layout/FocusedLayout';
import { FOCUSED_BUILDERS_ENABLED } from './event-layout/focusedBuildersEnabled';
import React, {useEffect, useRef, useState} from 'react'
import { FaRulerHorizontal } from "@react-icons/all-files/fa/FaRulerHorizontal";
import { FaRulerVertical } from "@react-icons/all-files/fa/FaRulerVertical";
import { FaRuler } from "@react-icons/all-files/fa/FaRuler";
import PicCont from './PicCont';
import { geoProductsUpdateAvailability, getAllFilteredProducts, getAllProducts, getProductsFilters, productsResetFilters } from '../store/slices/entities/products';
import { useSelector, useDispatch } from 'react-redux';
import { loadEntityForce } from '../store/slices/entities/crmActions';
import { showAlert, CLOSE_POPUP } from '../store/slices/ui';
import { helper } from '../utilities/helper';
import Button from './Button';
import { AiOutlineShoppingCart } from '@react-icons/all-files/ai/AiOutlineShoppingCart';
import { apiCallBegan } from '../store/api';
import { workingOrderReset, getWorkingOrder, workingOrderItemsReceived, workingOrderSetSettings } from '../store/slices/entities/orders';
import { cartAddItem, cartCleaned, getUser, getUserGeo } from '../store/slices/user';
import { getWorkingPackage, packageBuilderSet } from '../store/slices/entities/packages';
import { useRouter } from 'next/dist/client/router';
import { GiChoice } from "@react-icons/all-files/gi/GiChoice";
import { FaRulerCombined } from "@react-icons/all-files/fa/FaRulerCombined";
import * as gtag from '../lib/gtag'
import rigged from '../public/Pictures/video-wall-rental.png'
import floor from '../public/Pictures/frameless-rental.png'
import singleModule from '../public/Pictures/singleModule.png'
import hsegment from '../public/Pictures/hsegment.png'
import colLeft from '../public/Pictures/colLeft.png'
import colRight from '../public/Pictures/colRight.png'
import legLeft from '../public/Pictures/legLeft.png'
import legRight from '../public/Pictures/legRight.png'
import WallRender from './WallRender';
import { useOrderFlow } from './unified-order/OrderFlowProvider';
import { builderEquipmentPrice, builderFromConfiguration, createVideoWallConfiguration, getBuilderIndex, hydrateBuilderComponents } from '../utilities/builderConfiguration';
import styles from './BuilderExperience.module.scss';
import { resolveShoppingMarket } from '../utilities/fulfillmentMarket';
import { getAvailableVideoWallPitches, getVideoWallRecommendation, normalizeVideoWallPitch } from '../utilities/videoWallRecommendation';

const projectDetailLabels = {
    content: {
        presentation: 'Presentations or small text',
        video: 'Video or branding',
        camera: 'Live camera feed',
        mixed: 'Mixed content'
    },
    viewingDistance: {
        close: 'Under 10m / 33ft',
        medium: '10–20m / 33–66ft',
        far: 'Over 20m / 66ft'
    },
    environment: {
        indoor: 'Indoor',
        outdoor: 'Outdoor',
        unknown: 'Environment undecided'
    }
}

const getProjectDetailsSummary = projectDetails => {
    const labels = [
        projectDetailLabels.content[projectDetails.content],
        projectDetailLabels.viewingDistance[projectDetails.viewingDistance],
        projectDetailLabels.environment[projectDetails.environment]
    ].filter(Boolean)

    return labels.length ? labels.join(' · ') : 'No image-quality preferences selected'
}

const scrollBuilderElementIntoView = element => {
    if (!element || typeof window === 'undefined') return

    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
    element.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' })
}

const VideoWallBuilder = ({pre_height, pre_width, pre_Sheight, pre_sel, pre_pitch, pre_configuration, editingBuilderIndex}) => {
    const initialDimensions = pre_configuration?.dimensions
    let [height, setHeight] = useState(() => initialDimensions?.height || pre_height ? Number(initialDimensions?.height || pre_height) : 2)
    let [sHeight, setSHeight] = useState(() => initialDimensions?.structureHeight || pre_Sheight ? Number(initialDimensions?.structureHeight || pre_Sheight) : 3)
    let [pitch, setPitch] = useState(() => String(pre_configuration?.pitch || pre_pitch || '2.9'))
    let {push, pathname} = useRouter()
    let [width, setWidth] = useState(() => initialDimensions?.width || pre_width ? Number(initialDimensions?.width || pre_width) : 3)
    let [definition, setDefinition] = useState()
    let [rig, setRig] = useState()
    let [sel, setSel] = useState(() => pre_configuration?.mounting || pre_sel)
    let [setupOpen, setSetupOpen] = useState(() => !(pre_configuration?.mounting || pre_sel))
    let [projectDetails, setProjectDetails] = useState(pre_configuration?.projectDetails || {})
    const setupPanelRef = useRef(null)
    const resultHeadingRef = useRef(null)
    let products = useSelector(getAllProducts)
    let filters = useSelector(getProductsFilters)
    let dispatch= useDispatch()
    let { cart } = useSelector(getUser)
    let order = useSelector(getWorkingOrder)
    let pack = useSelector(getWorkingPackage)
    let geo = useSelector(getUserGeo)
    let shoppingMarket = resolveShoppingMarket({geo, order, pathname})
    let orlando = shoppingMarket === 'Orlando'
    let { launchIntent, unifiedEnabled } = useOrderFlow()
    let unifiedEligible = unifiedEnabled && !pack && !order?._id && !cart.items?.length
    const availablePitches = getAvailableVideoWallPitches({ environment: projectDetails.environment, orlando })
    useEffect(() => {
        if(filters.static) {
               dispatch(loadEntityForce('products'))
            dispatch(productsResetFilters())
        }
    }, [filters.static, dispatch])

    useEffect(() => {
        if(height >=sHeight || sHeight - height > 2) {
            let h = Math.floor(Number(height)+1)

            setSHeight(h)
        }
    }, [height, sHeight])

    useEffect(() => {
        const nextPitch = normalizeVideoWallPitch({ pitch, environment: projectDetails.environment, orlando })
        if (nextPitch !== pitch) setPitch(nextPitch)
    }, [orlando, pitch, projectDetails.environment])

    useEffect(() => {
        gtag.event({ action:  'vw_builder_click', label: 'leads', value: 3, category: 'orders' })
    }, [])

    useEffect(() => {
        if (sel) gtag.event({ action: 'builder_step_view', label: `video_wall_dimensions_${sel}`, value: 0, category: 'orders' })
    }, [sel])

    let getPrice =() => {
        if (!sel) return 0
        const configuration = createVideoWallConfiguration({ mounting: sel, width, height, structureHeight: sHeight, pitch, branch: shoppingMarket, projectDetails })
        return builderEquipmentPrice(hydrateBuilderComponents(configuration, products))
    }

    const showResults = mounting => {
        setSel(mounting)
        setSetupOpen(false)

        window.requestAnimationFrame(() => {
            resultHeadingRef.current?.focus({ preventScroll: true })
            scrollBuilderElementIntoView(resultHeadingRef.current)
        })
    }

    const editSetupChoices = () => {
        setSetupOpen(true)

        window.requestAnimationFrame(() => {
            const firstControl = setupPanelRef.current?.querySelector('select')
            firstControl?.focus({ preventScroll: true })
            scrollBuilderElementIntoView(setupPanelRef.current)
        })
    }


    let addToCartItems = async (delivery = true) => {
        if(order?.request_type === 'purchase' ) {
            if(!window.confirm(`This product is only available for rent, do you want to create a new rental order?`)) return
            else return   await dispatch(apiCallBegan({ url: `/order/${order._id}`, method: 'DELETE', onSuccess: workingOrderReset.type, onSuccessFunc: () => cartCleaned() }))
        }
        if (delivery !== undefined || unifiedEligible || pack) {
            gtag.event({ action: 'vw_builder_done', label: 'leads', value: 15, category: 'orders' })
        }
        const existingIndices = (pack?.builders || []).map(getBuilderIndex).filter(Number.isFinite)
        const numId = Number.isFinite(Number(editingBuilderIndex)) ? Number(editingBuilderIndex) : Math.max(0, ...existingIndices) + 1
        const configuration = createVideoWallConfiguration({
            mounting: sel,
            width,
            height,
            structureHeight: sHeight,
            pitch,
            branch: shoppingMarket,
            projectDetails
        })
        if (FOCUSED_BUILDERS_ENABLED && pre_configuration?.options) configuration.options = { ...pre_configuration.options }
        let _products = hydrateBuilderComponents(configuration, products)
        const resolved = await dispatch(apiCallBegan({
            url: '/inventory/pack/builder/resolve',
            method: 'POST',
            data: { configuration, index: numId },
            returnErrorData: true
        }))
        if (resolved?.errorMessage || resolved?.httpStatus || !resolved?.components?.length) {
            gtag.event({ action: 'builder_validation_error', label: resolved?.field || 'video_wall', value: 1, category: 'orders' })
            return dispatch(showAlert({ type: 'error', alert: resolved?.errorMessage || 'We could not verify this video wall configuration. Your order was not changed. Please try again.' }))
        }
        _products = resolved.components
        const builder = {
            ...builderFromConfiguration({ configuration, index: numId, components: _products }),
            component_checksum: resolved?.component_checksum,
            pricing: { equipment_per_day: resolved?.equipment_per_day ?? builderEquipmentPrice(_products), generated_at: new Date().toISOString() }
        }

        if (unifiedEligible) {
            dispatch(CLOSE_POPUP())
            return launchIntent({
                kind: 'configuration',
                entityName: `${width}m × ${height}m video wall`,
                sourceSurface: 'video_wall_builder',
                ...(delivery === undefined ? {} : { fulfillment: delivery ? 'delivery_setup' : 'pickup' }),
                components: _products.filter(component => component.product?._id && component.units > 0).map(component => ({
                    product: component.product._id,
                    units: component.units,
                    category: component.product.categories?.[0]?.split('/')?.[1]
                }))
            })
        }

        if(delivery && pack) {
            const previousBuilderIndex = Number.isFinite(Number(editingBuilderIndex)) ? Number(editingBuilderIndex) : undefined
            const previousComponents = Number.isFinite(previousBuilderIndex) ? (pack.components || []).filter(component => Number(component.builder_index) === previousBuilderIndex) : []
            previousComponents.forEach(component => dispatch(geoProductsUpdateAvailability({ product: component.product, units: component.units * -1 })))
            _products.forEach(component => dispatch(geoProductsUpdateAvailability(component)))
            dispatch(packageBuilderSet({ builder, components: _products, previousBuilderIndex }))
            dispatch(workingOrderItemsReceived([]))
            gtag.event({ action: 'builder_configuration_saved', label: Number.isFinite(previousBuilderIndex) ? 'video_wall_edit' : 'video_wall_new', value: 15, category: 'orders' })
            dispatch(CLOSE_POPUP())
            if(!pathname?.includes('planner')) {
                dispatch(workingOrderSetSettings({ step: 3, openSteps: 3 }))
                push(`/planner?id=${order._id}`)
              }

        } else if(delivery) {
            if(!cart.production  && order._id && !pack)  await   dispatch(apiCallBegan({url: `/order/${order._id}`, method: 'DELETE', onSuccess: workingOrderReset.type}))
            dispatch(CLOSE_POPUP())
            dispatch(cartAddItem({ products: _products, delivery: true, builder, numId }))
        }  else {
            // if (order?._id && units > 0 && (_pr.available - units < 0 || (_pr.bundle && _pr.included.some(ip => _products.find(produ => String(produ._id) == String(ip.product._id)).available - (units * ip.units) < 0)))) return dispatch(showAlert({ type: 'error', alert: `${product.name} has no more units available for the selected date` }))


            dispatch(CLOSE_POPUP())
          await  dispatch(cartAddItem({ products: _products, builder, numId }))
        }


    }

  const recommendation = getVideoWallRecommendation({ ...projectDetails, orlando })
  const projectDetailsSummary = getProjectDetailsSummary(projectDetails)
  const mountingLabel = sel === 'rigged' ? 'Truss mounted' : 'Floor mounted'
  const currentPrice = getPrice()

  return <div className={`videoWallBuilder stageBuilder ${styles.root} ${styles.videoWall}`}>

    <header className={`builderIntro ${sel && !setupOpen ? styles.introCompact : ''}`}>
        <div>
            <span className="builderEyebrow">Custom LED video wall builder</span>
            <h2 id="video-wall-builder-dialog-title">Configure your video wall</h2>
            <p>Choose how it is mounted, its exact dimensions and image quality. We will add the panels, processor, cabling and support structure as one setup.</p>
        </div>
        {Number.isFinite(Number(editingBuilderIndex)) && <span className="builderEditingBadge">Editing existing video wall</span>}
    </header>

    {sel && !setupOpen && <div className={styles.setupSummary} aria-label="Selected video wall setup">
        <div className={styles.summaryItem}>
            <span>Mounting</span>
            <strong>{mountingLabel}</strong>
        </div>
        <div className={styles.summaryItem}>
            <span>Project guidance</span>
            <strong>{projectDetailsSummary}</strong>
        </div>
        <button type="button" className={styles.editSetupButton} onClick={editSetupChoices} aria-expanded="false" aria-controls="video-wall-setup-choices">
            Edit setup choices
        </button>
    </div>}

    <div id="video-wall-setup-choices" ref={setupPanelRef} hidden={Boolean(sel && !setupOpen)}>
    <fieldset className="builderProjectDetails">
        <legend>Help us recommend image quality <span>Optional</span></legend>
        <label>Content
            <select value={projectDetails.content || ''} onChange={event => setProjectDetails(details => ({ ...details, content: event.target.value }))}>
                <option value="">Select content</option><option value="presentation">Presentations or small text</option><option value="video">Video or branding</option><option value="camera">Live camera feed</option><option value="mixed">Mixed content</option>
            </select>
        </label>
        <label>Closest viewer
            <select value={projectDetails.viewingDistance || ''} onChange={event => setProjectDetails(details => ({ ...details, viewingDistance: event.target.value }))}>
                <option value="">Select distance</option><option value="close">Under 10 meters / 33 feet</option><option value="medium">10–20 meters / 33–66 feet</option><option value="far">Over 20 meters / 66 feet</option>
            </select>
        </label>
        <label>Environment
            <select value={projectDetails.environment || ''} onChange={event => setProjectDetails(details => ({ ...details, environment: event.target.value }))}>
                <option value="">Select environment</option><option value="indoor">Indoor</option><option value="outdoor">Outdoor</option><option value="unknown">Not sure yet</option>
            </select>
        </label>
        {recommendation && <p className="builderRecommendation" role="status">{recommendation}</p>}
    </fieldset>

    <h3 className={`stepTitle thick`}><GiChoice aria-hidden="true" />Step 1 · Choose video wall mounting</h3>
    <div className={`selectRow ${sel ? 'noPad' : ''}`}>
        <button type="button" aria-pressed={sel === 'floor'} className={`${sel ? 'selMade' : ''} ${sel === 'floor'? "optionCont sel" :"optionCont"}`} onClick={() => showResults('floor')}>

            <PicCont width={600} height={600} src={floor} alt="" />
            <div className="col">
                <strong>Floor mounted</strong>
                <p>A clean, frameless look supported by a structure hidden behind the panels.</p>

            </div>

        </button>
        <button type="button" aria-pressed={sel === 'rigged'} className={`${sel ? 'selMade' : ''} rev ${sel === 'rigged'? "optionCont sel" :"optionCont"}`} onClick={() => showResults('rigged')}>
        <div className="col">
                <strong>Truss mounted</strong>
                <p>The wall hangs from a visible truss structure for elevated or large displays.</p>

            </div>
            <PicCont  width={600} height={600} src={rigged} alt=""/>


        </button>
    </div>
    </div>
{sel &&  <>
    <h3 ref={resultHeadingRef} id="video-wall-results" tabIndex="-1" className={`stepTitle thick ${styles.resultHeading}`}><FaRulerCombined aria-hidden="true" />Step 2 · Choose dimensions and image quality</h3>
    <div className={styles.quickEstimate} aria-label="Current video wall estimate">
        <div className={styles.estimatePrice}>
            <span>Current equipment estimate</span>
            <output aria-live="polite">{helper.formatPrice(currentPrice)}</output>
            <small>24-hour rental · Estimated labor {helper.formatPrice(currentPrice * 0.45)}</small>
        </div>
        <div className={`buttons ${styles.quickEstimateActions}`}>
            {pack ?
                <Button className='btn-4 highLight ' button_name={'add_product'} onClick={() => addToCartItems(true)}><AiOutlineShoppingCart /> {Number.isFinite(Number(editingBuilderIndex)) ? 'Save video wall changes' : 'Add video wall to setup'}</Button>
                :
                <Button onClick={() => addToCartItems(true)} className={`btn-4 highLight`}><AiOutlineShoppingCart />Choose dates and rent online</Button>}
        </div>
    </div>
<div className="axisRow">
     <div className={`mainCol  `}>
        <div className={styles.previewHeading}>
            <div>
                <span>Live preview</span>
                <strong>{width}m × {height}m video wall</strong>
            </div>
            <small>{sel === 'rigged' ? 'Truss mounted' : 'Floor mounted'} · {pitch}mm pitch</small>
        </div>
        <div className={styles.resolution}>
            <div>Screen Resolution</div>
            <div className="res">{Math.round((width*2)* Math.round(500/ Number(pitch)))}x{Math.round((height*2)* Math.round(500/ Number(pitch)))}</div>

        </div>
      <FocusedLayout configuration={sel ? createVideoWallConfiguration({ mounting: sel, width, height, structureHeight: sHeight, pitch, branch: shoppingMarket, projectDetails }) : null} onRestoreConfiguration={saved => {
        setSel(saved.mounting); setWidth(saved.dimensions.width); setHeight(saved.dimensions.height); setSHeight(saved.dimensions.structureHeight); setPitch(String(saved.pitch)); setProjectDetails(saved.projectDetails || {})
      }}><WallRender sel={sel} sHeight={sHeight} height={height} width={width} /></FocusedLayout>
      </div>
        <div className="sideCol">
            <div className={styles.panelHeading}>
                <span>Configuration</span>
                <p>Set image quality and dimensions. Pricing updates automatically.</p>
            </div>
                    <div className='inputRow'>
        <span className='meas'>Pixel pitch:</span>
        <div className={styles.control}>

                <label htmlFor='video-wall-pitch' aria-label="Pixel pitch"><FaRulerHorizontal /></label>

                <select  id='video-wall-pitch' value={pitch} onChange={e => {

                    setPitch(e.target.value)
                } } >
                    {availablePitches.map(value => <option key={value} value={value}>
                        {value === '1.9' ? '1.9mm (Max Resolution)' : value === '2.9' ? '2.9mm (High Resolution)' : '4.8mm (Low Resolution)'}
                    </option>)}
                </select>


            </div>
            </div>
        <div className='inputRow'>
        <span className='meas'>Width:</span>
        <div className={styles.control}>

                <label htmlFor='video-wall-width' aria-label="Video wall width"><FaRulerHorizontal /></label>

                <select  id='video-wall-width' value={width} onChange={e => {
                    if((height*e.target.value*4) > 150) return dispatch(showAlert({type: 'error', alert: 'This configuration is not possible! Please try reducing the Height or the Width'}))

                    setWidth(e.target.value)
                } } >
                    {[0.5,1,1.5,2,2.5,3,3.5,4,4.5,5,5.5,6,6.5,7,7.5,8,8.5,9,9.5,10,10.5,11,11.5,12,12.5].map((l,i) => <option key={i} value={l}>{l} meters ({(l *3.28084).toFixed(2)} ft)</option>) }


                </select>


            </div>
            </div>
            <div className='inputRow'>
            <span className='meas'>Height:</span>
        <div className={styles.control}>
                <label htmlFor='video-wall-height' aria-label="Video wall height"><FaRulerVertical /></label>

                <select  id='video-wall-height' value={height} onChange={e => {
                    if((width*e.target.value*4) > 150) return dispatch(showAlert({type: 'error', alert: 'This configuration is not possible! Please try reducing the Height or the Width'}))
                   setHeight(e.target.value)
                } } >
            {[0.5,1,1.5,2,2.5,3,3.5,4,4.5,5,5.5,6,6.5,7,7.5,8,8.5,9,9.5,10,10.5,11,11.5,12.5].map((l,i) => <option key={i} value={l}>{l} meters ({(l *3.28084).toFixed(2)} ft)</option>) }


     </select>

            </div>
            </div>
   {sel === 'rigged'    &&<div className='inputRow'>    <span className='meas'>Structure Height:</span>
        <div className={styles.control}>
                <label htmlFor='video-wall-structure-height' aria-label="Support structure height"><FaRulerVertical /></label>

                <select  id='video-wall-structure-height' value={sHeight} onChange={e => {


                   setSHeight(e.target.value)
                } } >
       {[2,3,4,5,6,7,8,9,10].filter(h => h > height).map((l,i) => <option key={i} value={l}>{l} meters ({(l *3.28084).toFixed(2)} ft)</option>) }
                    </select>

            </div>  </div> }
            <p className={styles.laborNote}>Final delivery and installation pricing is calculated after you provide the event dates and location.</p>
        </div>

    </div>

    </>  }


  </div>
}

export default VideoWallBuilder
